import {
  IndividualLevelCrossing,
  LevelCrossingLinkedLocation,
  LevelCrossingRailManager,
  LevelCrossingSite,
  LevelCrossingSiteMetadata,
  LevelCrossingVersionEntry,
} from "../../models/level-crossing-sites";

type RawLevelCrossingSite = Omit<
  LevelCrossingSite,
  | "SuburbOrTown"
  | "RoadManager"
  | "LocalCouncil"
  | "RailInfrastructureManagers"
  | "LinkedLocations"
  | "IndividualLevelCrossings"
  | "Version"
  | "Versions"
>;

const rawLevelCrossingSites: RawLevelCrossingSite[] = [
    {
      "Id": 271099,
      "ONRSRRef": 595676,
      "LevelCrossingSiteStatus": "Operational",
      "StateId": "5",
      "State_Label": "Queensland",
      "LevelCrossingSiteName": "LC Site 1",
      "LevelCrossingSiteID": 409665,
      "AlcamID": 658626,
      "NumberOfLevelCrossings": 2,
      "LevelCrossingOntologyStatusID": "3",
      "LevelCrossingOntologyStatus_Label": "Submitted",
      "ValidationStatusId": "1",
      "ValidationStatus_Label": "Queried",
      "LinkItemId": 159855,
      "info": [
        {
          "LevelCrossingTypeId": "2",
          "LevelCrossingTypeLabel": "Pedestrian",
          "TrackCount": 4
        },
        {
          "LevelCrossingTypeId": "2",
          "LevelCrossingTypeLabel": "Pedestrian",
          "TrackCount": 4
        }
      ]
    },
    {
      "Id": 715348,
      "ONRSRRef": 293242,
      "LevelCrossingSiteStatus": "Operational",
      "StateId": "3",
      "State_Label": "Victoria",
      "LevelCrossingSiteName": "LC Site 2",
      "LevelCrossingSiteID": 330990,
      "AlcamID": 678083,
      "NumberOfLevelCrossings": 6,
      "LevelCrossingOntologyStatusID": "3",
      "LevelCrossingOntologyStatus_Label": "Submitted",
      "ValidationStatusId": "5",
      "ValidationStatus_Label": "Pending Validation",
      "LinkItemId": 705909,
      "info": [
        {
          "LevelCrossingTypeId": "2",
          "LevelCrossingTypeLabel": "Pedestrian",
          "TrackCount": 4
        }
      ]
    },
    {
      "Id": 441289,
      "ONRSRRef": 688912,
      "LevelCrossingSiteStatus": "Decommissioned",
      "StateId": "4",
      "State_Label": "Australian Capital Territory",
      "LevelCrossingSiteName": "LC Site 3",
      "LevelCrossingSiteID": 204812,
      "AlcamID": 967152,
      "NumberOfLevelCrossings": 6,
      "LevelCrossingOntologyStatusID": "3",
      "LevelCrossingOntologyStatus_Label": "Submitted",
      "ValidationStatusId": "4",
      "ValidationStatus_Label": "Delete Requested",
      "LinkItemId": 576728,
      "info": [
        {
          "LevelCrossingTypeId": "2",
          "LevelCrossingTypeLabel": "Pedestrian",
          "TrackCount": 3
        },
        {
          "LevelCrossingTypeId": "2",
          "LevelCrossingTypeLabel": "Pedestrian",
          "TrackCount": 1
        }
      ]
    },
    {
      "Id": 893825,
      "ONRSRRef": 895957,
      "LevelCrossingSiteStatus": "Operational",
      "StateId": "8",
      "State_Label": "South Australia",
      "LevelCrossingSiteName": "LC Site 4",
      "LevelCrossingSiteID": 417805,
      "AlcamID": 544338,
      "NumberOfLevelCrossings": 4,
      "LevelCrossingOntologyStatusID": "1",
      "LevelCrossingOntologyStatus_Label": "Awaiting Further Information",
      "ValidationStatusId": "5",
      "ValidationStatus_Label": "Pending Validation",
      "LinkItemId": 518845,
      "info": [
        {
          "LevelCrossingTypeId": "2",
          "LevelCrossingTypeLabel": "Pedestrian",
          "TrackCount": 1
        }
      ]
    },
    {
      "Id": 932487,
      "ONRSRRef": 137372,
      "LevelCrossingSiteStatus": "Decommissioned",
      "StateId": "2",
      "State_Label": "Northern Territory",
      "LevelCrossingSiteName": "LC Site 5",
      "LevelCrossingSiteID": 811050,
      "AlcamID": 547809,
      "NumberOfLevelCrossings": 1,
      "LevelCrossingOntologyStatusID": "3",
      "LevelCrossingOntologyStatus_Label": "Submitted",
      "ValidationStatusId": "5",
      "ValidationStatus_Label": "Pending Validation",
      "LinkItemId": 142053,
      "info": [
        {
          "LevelCrossingTypeId": "2",
          "LevelCrossingTypeLabel": "Pedestrian",
          "TrackCount": 4
        },
        {
          "LevelCrossingTypeId": "2",
          "LevelCrossingTypeLabel": "Pedestrian",
          "TrackCount": 3
        },
        {
          "LevelCrossingTypeId": "2",
          "LevelCrossingTypeLabel": "Pedestrian",
          "TrackCount": 2
        }
      ]
    },
    {
      "Id": 366309,
      "ONRSRRef": 395189,
      "LevelCrossingSiteStatus": "Operational",
      "StateId": "7",
      "State_Label": "Tasmania",
      "LevelCrossingSiteName": "LC Site 6",
      "LevelCrossingSiteID": 450438,
      "AlcamID": 785054,
      "NumberOfLevelCrossings": 4,
      "LevelCrossingOntologyStatusID": "1",
      "LevelCrossingOntologyStatus_Label": "Awaiting Further Information",
      "ValidationStatusId": "3",
      "ValidationStatus_Label": "Open",
      "LinkItemId": 787958,
      "info": [
        {
          "LevelCrossingTypeId": "1",
          "LevelCrossingTypeLabel": "Road Vehicle",
          "TrackCount": 1
        }
      ]
    },
    {
      "Id": 282692,
      "ONRSRRef": 204908,
      "LevelCrossingSiteStatus": "Non-operational",
      "StateId": "8",
      "State_Label": "South Australia",
      "LevelCrossingSiteName": "LC Site 7",
      "LevelCrossingSiteID": 949976,
      "AlcamID": 260238,
      "NumberOfLevelCrossings": 4,
      "LevelCrossingOntologyStatusID": "2",
      "LevelCrossingOntologyStatus_Label": "Deleted",
      "ValidationStatusId": "2",
      "ValidationStatus_Label": "Closed",
      "LinkItemId": 892161,
      "info": [
        {
          "LevelCrossingTypeId": "2",
          "LevelCrossingTypeLabel": "Pedestrian",
          "TrackCount": 4
        }
      ]
    },
    {
      "Id": 291404,
      "ONRSRRef": 183289,
      "LevelCrossingSiteStatus": "Decommissioned",
      "StateId": "3",
      "State_Label": "Victoria",
      "LevelCrossingSiteName": "LC Site 8",
      "LevelCrossingSiteID": 283673,
      "AlcamID": 824489,
      "NumberOfLevelCrossings": 2,
      "LevelCrossingOntologyStatusID": "2",
      "LevelCrossingOntologyStatus_Label": "Deleted",
      "ValidationStatusId": "5",
      "ValidationStatus_Label": "Pending Validation",
      "LinkItemId": 679477,
      "info": [
        {
          "LevelCrossingTypeId": "1",
          "LevelCrossingTypeLabel": "Road Vehicle",
          "TrackCount": 2
        },
        {
          "LevelCrossingTypeId": "1",
          "LevelCrossingTypeLabel": "Road Vehicle",
          "TrackCount": 2
        },
        {
          "LevelCrossingTypeId": "1",
          "LevelCrossingTypeLabel": "Road Vehicle",
          "TrackCount": 1
        }
      ]
    },
    {
      "Id": 916837,
      "ONRSRRef": 836245,
      "LevelCrossingSiteStatus": "Operational",
      "StateId": "2",
      "State_Label": "Northern Territory",
      "LevelCrossingSiteName": "LC Site 9",
      "LevelCrossingSiteID": 388059,
      "AlcamID": 823205,
      "NumberOfLevelCrossings": 1,
      "LevelCrossingOntologyStatusID": "2",
      "LevelCrossingOntologyStatus_Label": "Deleted",
      "ValidationStatusId": "3",
      "ValidationStatus_Label": "Open",
      "LinkItemId": 779517,
      "info": [
        {
          "LevelCrossingTypeId": "1",
          "LevelCrossingTypeLabel": "Road Vehicle",
          "TrackCount": 3
        },
        {
          "LevelCrossingTypeId": "1",
          "LevelCrossingTypeLabel": "Road Vehicle",
          "TrackCount": 4
        }
      ]
    },
    {
      "Id": 998991,
      "ONRSRRef": 206255,
      "LevelCrossingSiteStatus": "Decommissioned",
      "StateId": "6",
      "State_Label": "Western Australia",
      "LevelCrossingSiteName": "LC Site 10",
      "LevelCrossingSiteID": 290767,
      "AlcamID": 265478,
      "NumberOfLevelCrossings": 4,
      "LevelCrossingOntologyStatusID": "2",
      "LevelCrossingOntologyStatus_Label": "Deleted",
      "ValidationStatusId": "1",
      "ValidationStatus_Label": "Queried",
      "LinkItemId": 228775,
      "info": [
        {
          "LevelCrossingTypeId": "1",
          "LevelCrossingTypeLabel": "Road Vehicle",
          "TrackCount": 3
        },
        {
          "LevelCrossingTypeId": "1",
          "LevelCrossingTypeLabel": "Road Vehicle",
          "TrackCount": 2
        }
      ]
    },
    {
      "Id": 965628,
      "ONRSRRef": 497712,
      "LevelCrossingSiteStatus": "Operational",
      "StateId": "6",
      "State_Label": "Western Australia",
      "LevelCrossingSiteName": "LC Site 11",
      "LevelCrossingSiteID": 610281,
      "AlcamID": 905886,
      "NumberOfLevelCrossings": 6,
      "LevelCrossingOntologyStatusID": "2",
      "LevelCrossingOntologyStatus_Label": "Deleted",
      "ValidationStatusId": "4",
      "ValidationStatus_Label": "Delete Requested",
      "LinkItemId": 954209,
      "info": [
        {
          "LevelCrossingTypeId": "2",
          "LevelCrossingTypeLabel": "Pedestrian",
          "TrackCount": 1
        },
        {
          "LevelCrossingTypeId": "2",
          "LevelCrossingTypeLabel": "Pedestrian",
          "TrackCount": 4
        }
      ]
    },
    {
      "Id": 348214,
      "ONRSRRef": 556917,
      "LevelCrossingSiteStatus": "Non-operational",
      "StateId": "5",
      "State_Label": "Queensland",
      "LevelCrossingSiteName": "LC Site 12",
      "LevelCrossingSiteID": 781855,
      "AlcamID": 371149,
      "NumberOfLevelCrossings": 5,
      "LevelCrossingOntologyStatusID": "3",
      "LevelCrossingOntologyStatus_Label": "Submitted",
      "ValidationStatusId": "4",
      "ValidationStatus_Label": "Delete Requested",
      "LinkItemId": 572987,
      "info": [
        {
          "LevelCrossingTypeId": "2",
          "LevelCrossingTypeLabel": "Pedestrian",
          "TrackCount": 3
        }
      ]
    },
    {
      "Id": 299257,
      "ONRSRRef": 727102,
      "LevelCrossingSiteStatus": "Operational",
      "StateId": "3",
      "State_Label": "Victoria",
      "LevelCrossingSiteName": "LC Site 13",
      "LevelCrossingSiteID": 156127,
      "AlcamID": 779508,
      "NumberOfLevelCrossings": 6,
      "LevelCrossingOntologyStatusID": "3",
      "LevelCrossingOntologyStatus_Label": "Submitted",
      "ValidationStatusId": "1",
      "ValidationStatus_Label": "Queried",
      "LinkItemId": 486721,
      "info": [
        {
          "LevelCrossingTypeId": "2",
          "LevelCrossingTypeLabel": "Pedestrian",
          "TrackCount": 1
        },
        {
          "LevelCrossingTypeId": "2",
          "LevelCrossingTypeLabel": "Pedestrian",
          "TrackCount": 1
        }
      ]
    },
    {
      "Id": 768649,
      "ONRSRRef": 455078,
      "LevelCrossingSiteStatus": "Operational",
      "StateId": "8",
      "State_Label": "South Australia",
      "LevelCrossingSiteName": "LC Site 14",
      "LevelCrossingSiteID": 468916,
      "AlcamID": 635572,
      "NumberOfLevelCrossings": 4,
      "LevelCrossingOntologyStatusID": "1",
      "LevelCrossingOntologyStatus_Label": "Awaiting Further Information",
      "ValidationStatusId": "4",
      "ValidationStatus_Label": "Delete Requested",
      "LinkItemId": 975802,
      "info": [
        {
          "LevelCrossingTypeId": "2",
          "LevelCrossingTypeLabel": "Pedestrian",
          "TrackCount": 1
        }
      ]
    },
    {
      "Id": 701596,
      "ONRSRRef": 413169,
      "LevelCrossingSiteStatus": "Non-operational",
      "StateId": "4",
      "State_Label": "Australian Capital Territory",
      "LevelCrossingSiteName": "LC Site 15",
      "LevelCrossingSiteID": 602183,
      "AlcamID": 923190,
      "NumberOfLevelCrossings": 4,
      "LevelCrossingOntologyStatusID": "3",
      "LevelCrossingOntologyStatus_Label": "Submitted",
      "ValidationStatusId": "1",
      "ValidationStatus_Label": "Queried",
      "LinkItemId": 331183,
      "info": [
        {
          "LevelCrossingTypeId": "2",
          "LevelCrossingTypeLabel": "Pedestrian",
          "TrackCount": 1
        },
        {
          "LevelCrossingTypeId": "2",
          "LevelCrossingTypeLabel": "Pedestrian",
          "TrackCount": 4
        }
      ]
    },
    {
      "Id": 813451,
      "ONRSRRef": 727023,
      "LevelCrossingSiteStatus": "Non-operational",
      "StateId": "3",
      "State_Label": "Victoria",
      "LevelCrossingSiteName": "LC Site 16",
      "LevelCrossingSiteID": 185984,
      "AlcamID": 752577,
      "NumberOfLevelCrossings": 5,
      "LevelCrossingOntologyStatusID": "2",
      "LevelCrossingOntologyStatus_Label": "Deleted",
      "ValidationStatusId": "2",
      "ValidationStatus_Label": "Closed",
      "LinkItemId": 131587,
      "info": [
        {
          "LevelCrossingTypeId": "2",
          "LevelCrossingTypeLabel": "Pedestrian",
          "TrackCount": 1
        }
      ]
    },
    {
      "Id": 262196,
      "ONRSRRef": 373985,
      "LevelCrossingSiteStatus": "Non-operational",
      "StateId": "2",
      "State_Label": "Northern Territory",
      "LevelCrossingSiteName": "LC Site 17",
      "LevelCrossingSiteID": 479600,
      "AlcamID": 341306,
      "NumberOfLevelCrossings": 2,
      "LevelCrossingOntologyStatusID": "3",
      "LevelCrossingOntologyStatus_Label": "Submitted",
      "ValidationStatusId": "5",
      "ValidationStatus_Label": "Pending Validation",
      "LinkItemId": 247052,
      "info": [
        {
          "LevelCrossingTypeId": "2",
          "LevelCrossingTypeLabel": "Pedestrian",
          "TrackCount": 1
        },
        {
          "LevelCrossingTypeId": "2",
          "LevelCrossingTypeLabel": "Pedestrian",
          "TrackCount": 2
        },
        {
          "LevelCrossingTypeId": "2",
          "LevelCrossingTypeLabel": "Pedestrian",
          "TrackCount": 2
        }
      ]
    },
    {
      "Id": 940681,
      "ONRSRRef": 496239,
      "LevelCrossingSiteStatus": "Decommissioned",
      "StateId": "3",
      "State_Label": "Victoria",
      "LevelCrossingSiteName": "LC Site 18",
      "LevelCrossingSiteID": 639093,
      "AlcamID": 573076,
      "NumberOfLevelCrossings": 5,
      "LevelCrossingOntologyStatusID": "2",
      "LevelCrossingOntologyStatus_Label": "Deleted",
      "ValidationStatusId": "4",
      "ValidationStatus_Label": "Delete Requested",
      "LinkItemId": 394769,
      "info": [
        {
          "LevelCrossingTypeId": "1",
          "LevelCrossingTypeLabel": "Road Vehicle",
          "TrackCount": 3
        }
      ]
    },
    {
      "Id": 710960,
      "ONRSRRef": 810333,
      "LevelCrossingSiteStatus": "Decommissioned",
      "StateId": "8",
      "State_Label": "South Australia",
      "LevelCrossingSiteName": "LC Site 19",
      "LevelCrossingSiteID": 229472,
      "AlcamID": 869569,
      "NumberOfLevelCrossings": 1,
      "LevelCrossingOntologyStatusID": "1",
      "LevelCrossingOntologyStatus_Label": "Awaiting Further Information",
      "ValidationStatusId": "5",
      "ValidationStatus_Label": "Pending Validation",
      "LinkItemId": 388440,
      "info": [
        {
          "LevelCrossingTypeId": "1",
          "LevelCrossingTypeLabel": "Road Vehicle",
          "TrackCount": 3
        },
        {
          "LevelCrossingTypeId": "1",
          "LevelCrossingTypeLabel": "Road Vehicle",
          "TrackCount": 4
        },
        {
          "LevelCrossingTypeId": "1",
          "LevelCrossingTypeLabel": "Road Vehicle",
          "TrackCount": 2
        }
      ]
    },
    {
      "Id": 200199,
      "ONRSRRef": 983067,
      "LevelCrossingSiteStatus": "Operational",
      "StateId": "6",
      "State_Label": "Western Australia",
      "LevelCrossingSiteName": "LC Site 20",
      "LevelCrossingSiteID": 837090,
      "AlcamID": 207669,
      "NumberOfLevelCrossings": 4,
      "LevelCrossingOntologyStatusID": "2",
      "LevelCrossingOntologyStatus_Label": "Deleted",
      "ValidationStatusId": "3",
      "ValidationStatus_Label": "Open",
      "LinkItemId": 248982,
      "info": [
        {
          "LevelCrossingTypeId": "1",
          "LevelCrossingTypeLabel": "Road Vehicle",
          "TrackCount": 3
        },
        {
          "LevelCrossingTypeId": "1",
          "LevelCrossingTypeLabel": "Road Vehicle",
          "TrackCount": 2
        },
        {
          "LevelCrossingTypeId": "1",
          "LevelCrossingTypeLabel": "Road Vehicle",
          "TrackCount": 4
        }
      ]
    },
    {
      "Id": 104748,
      "ONRSRRef": 881538,
      "LevelCrossingSiteStatus": "Non-operational",
      "StateId": "4",
      "State_Label": "Australian Capital Territory",
      "LevelCrossingSiteName": "LC Site 21",
      "LevelCrossingSiteID": 313166,
      "AlcamID": 189445,
      "NumberOfLevelCrossings": 6,
      "LevelCrossingOntologyStatusID": "3",
      "LevelCrossingOntologyStatus_Label": "Submitted",
      "ValidationStatusId": "1",
      "ValidationStatus_Label": "Queried",
      "LinkItemId": 589092,
      "info": [
        {
          "LevelCrossingTypeId": "1",
          "LevelCrossingTypeLabel": "Road Vehicle",
          "TrackCount": 4
        }
      ]
    },
    {
      "Id": 965539,
      "ONRSRRef": 213561,
      "LevelCrossingSiteStatus": "Decommissioned",
      "StateId": "6",
      "State_Label": "Western Australia",
      "LevelCrossingSiteName": "LC Site 22",
      "LevelCrossingSiteID": 356370,
      "AlcamID": 575590,
      "NumberOfLevelCrossings": 4,
      "LevelCrossingOntologyStatusID": "2",
      "LevelCrossingOntologyStatus_Label": "Deleted",
      "ValidationStatusId": "2",
      "ValidationStatus_Label": "Closed",
      "LinkItemId": 185121,
      "info": [
        {
          "LevelCrossingTypeId": "2",
          "LevelCrossingTypeLabel": "Pedestrian",
          "TrackCount": 1
        }
      ]
    },
    {
      "Id": 694857,
      "ONRSRRef": 208750,
      "LevelCrossingSiteStatus": "Decommissioned",
      "StateId": "5",
      "State_Label": "Queensland",
      "LevelCrossingSiteName": "LC Site 23",
      "LevelCrossingSiteID": 984650,
      "AlcamID": 833235,
      "NumberOfLevelCrossings": 2,
      "LevelCrossingOntologyStatusID": "2",
      "LevelCrossingOntologyStatus_Label": "Deleted",
      "ValidationStatusId": "4",
      "ValidationStatus_Label": "Delete Requested",
      "LinkItemId": 147435,
      "info": [
        {
          "LevelCrossingTypeId": "2",
          "LevelCrossingTypeLabel": "Pedestrian",
          "TrackCount": 1
        }
      ]
    },
    {
      "Id": 630505,
      "ONRSRRef": 912421,
      "LevelCrossingSiteStatus": "Operational",
      "StateId": "5",
      "State_Label": "Queensland",
      "LevelCrossingSiteName": "LC Site 24",
      "LevelCrossingSiteID": 635747,
      "AlcamID": 540462,
      "NumberOfLevelCrossings": 4,
      "LevelCrossingOntologyStatusID": "3",
      "LevelCrossingOntologyStatus_Label": "Submitted",
      "ValidationStatusId": "2",
      "ValidationStatus_Label": "Closed",
      "LinkItemId": 393719,
      "info": [
        {
          "LevelCrossingTypeId": "2",
          "LevelCrossingTypeLabel": "Pedestrian",
          "TrackCount": 2
        },
        {
          "LevelCrossingTypeId": "2",
          "LevelCrossingTypeLabel": "Pedestrian",
          "TrackCount": 3
        }
      ]
    },
    {
      "Id": 361812,
      "ONRSRRef": 627846,
      "LevelCrossingSiteStatus": "Decommissioned",
      "StateId": "7",
      "State_Label": "Tasmania",
      "LevelCrossingSiteName": "LC Site 25",
      "LevelCrossingSiteID": 151557,
      "AlcamID": 808183,
      "NumberOfLevelCrossings": 4,
      "LevelCrossingOntologyStatusID": "2",
      "LevelCrossingOntologyStatus_Label": "Deleted",
      "ValidationStatusId": "2",
      "ValidationStatus_Label": "Closed",
      "LinkItemId": 951862,
      "info": [
        {
          "LevelCrossingTypeId": "1",
          "LevelCrossingTypeLabel": "Road Vehicle",
          "TrackCount": 3
        }
      ]
    },
    {
      "Id": 846210,
      "ONRSRRef": 504113,
      "LevelCrossingSiteStatus": "Operational",
      "StateId": "5",
      "State_Label": "Queensland",
      "LevelCrossingSiteName": "LC Site 26",
      "LevelCrossingSiteID": 808790,
      "AlcamID": 342527,
      "NumberOfLevelCrossings": 1,
      "LevelCrossingOntologyStatusID": "2",
      "LevelCrossingOntologyStatus_Label": "Deleted",
      "ValidationStatusId": "2",
      "ValidationStatus_Label": "Closed",
      "LinkItemId": 441383,
      "info": [
        {
          "LevelCrossingTypeId": "1",
          "LevelCrossingTypeLabel": "Road Vehicle",
          "TrackCount": 1
        },
        {
          "LevelCrossingTypeId": "1",
          "LevelCrossingTypeLabel": "Road Vehicle",
          "TrackCount": 4
        }
      ]
    },
    {
      "Id": 861791,
      "ONRSRRef": 254532,
      "LevelCrossingSiteStatus": "Non-operational",
      "StateId": "3",
      "State_Label": "Victoria",
      "LevelCrossingSiteName": "LC Site 27",
      "LevelCrossingSiteID": 125479,
      "AlcamID": 585337,
      "NumberOfLevelCrossings": 5,
      "LevelCrossingOntologyStatusID": "3",
      "LevelCrossingOntologyStatus_Label": "Submitted",
      "ValidationStatusId": "4",
      "ValidationStatus_Label": "Delete Requested",
      "LinkItemId": 136231,
      "info": [
        {
          "LevelCrossingTypeId": "2",
          "LevelCrossingTypeLabel": "Pedestrian",
          "TrackCount": 4
        }
      ]
    },
    {
      "Id": 191326,
      "ONRSRRef": 514144,
      "LevelCrossingSiteStatus": "Operational",
      "StateId": "5",
      "State_Label": "Queensland",
      "LevelCrossingSiteName": "LC Site 28",
      "LevelCrossingSiteID": 793680,
      "AlcamID": 589027,
      "NumberOfLevelCrossings": 4,
      "LevelCrossingOntologyStatusID": "1",
      "LevelCrossingOntologyStatus_Label": "Awaiting Further Information",
      "ValidationStatusId": "4",
      "ValidationStatus_Label": "Delete Requested",
      "LinkItemId": 109251,
      "info": [
        {
          "LevelCrossingTypeId": "1",
          "LevelCrossingTypeLabel": "Road Vehicle",
          "TrackCount": 4
        },
        {
          "LevelCrossingTypeId": "1",
          "LevelCrossingTypeLabel": "Road Vehicle",
          "TrackCount": 3
        }
      ]
    },
    {
      "Id": 431278,
      "ONRSRRef": 797032,
      "LevelCrossingSiteStatus": "Decommissioned",
      "StateId": "5",
      "State_Label": "Queensland",
      "LevelCrossingSiteName": "LC Site 29",
      "LevelCrossingSiteID": 661284,
      "AlcamID": 244527,
      "NumberOfLevelCrossings": 5,
      "LevelCrossingOntologyStatusID": "2",
      "LevelCrossingOntologyStatus_Label": "Deleted",
      "ValidationStatusId": "4",
      "ValidationStatus_Label": "Delete Requested",
      "LinkItemId": 516557,
      "info": [
        {
          "LevelCrossingTypeId": "1",
          "LevelCrossingTypeLabel": "Road Vehicle",
          "TrackCount": 1
        },
        {
          "LevelCrossingTypeId": "1",
          "LevelCrossingTypeLabel": "Road Vehicle",
          "TrackCount": 1
        },
        {
          "LevelCrossingTypeId": "1",
          "LevelCrossingTypeLabel": "Road Vehicle",
          "TrackCount": 4
        }
      ]
    },
    {
      "Id": 332298,
      "ONRSRRef": 412208,
      "LevelCrossingSiteStatus": "Operational",
      "StateId": "7",
      "State_Label": "Tasmania",
      "LevelCrossingSiteName": "LC Site 30",
      "LevelCrossingSiteID": 532340,
      "AlcamID": 897105,
      "NumberOfLevelCrossings": 6,
      "LevelCrossingOntologyStatusID": "2",
      "LevelCrossingOntologyStatus_Label": "Deleted",
      "ValidationStatusId": "5",
      "ValidationStatus_Label": "Pending Validation",
      "LinkItemId": 671556,
      "info": [
        {
          "LevelCrossingTypeId": "1",
          "LevelCrossingTypeLabel": "Road Vehicle",
          "TrackCount": 2
        }
      ]
    }
  ];

const SUBURBS = ["Benalla", "Seymour", "Shepparton", "Wangaratta", "Albury", "Wodonga"];
const ROAD_MANAGERS = ["Department of Transport", "VicRoads", "Local Council"];
const LOCAL_COUNCILS = ["Benalla Rural City", "Greater Shepparton", "Wangaratta Rural City"];
const RAIL_MANAGERS = ["Australian Rail Track Corporation Limited", "Operator Rail Pty Ltd"];
const LOCATION_TYPES = ["Line Section", "Yard/Siding", "Bridge (rail)", "Station"];
const LC_TYPES = ["Road Vehicle", "Pedestrian", "Occupation"];
const LC_PROTECTION_TYPES = ["Passive - Stop", "Active - Flashing Lights", "Active - Boom Gates"];

function buildRailManagers(idx: number): LevelCrossingRailManager[] {
  return [{
    RailInfrastructureManagerName: RAIL_MANAGERS[idx % RAIL_MANAGERS.length],
    NumberOfTracks: ((idx * 3) % 4) + 1,
    TrackSpeed: 40 + ((idx * 7) % 60),
    TrafficDensity: 10 + ((idx * 5) % 40),
  }];
}

function buildLinkedLocations(idx: number): LevelCrossingLinkedLocation[] {
  return [{
    RailInfrastructureManagerName: RAIL_MANAGERS[idx % RAIL_MANAGERS.length],
    DefinedLocationTypeName: LOCATION_TYPES[idx % LOCATION_TYPES.length],
    LocationName: `Benalla Junction To Yarrawonga ${idx + 1}`,
    LocationId: `BGG-YRW-${String(45000 + idx).slice(-5)}`,
    KMPoint: (((idx * 11) % 1000) / 10).toFixed(2),
  }];
}

function buildIndividualCrossings(idx: number, site: RawLevelCrossingSite): IndividualLevelCrossing[] {
  const count = Math.max(1, site.NumberOfLevelCrossings || 1);
  const out: IndividualLevelCrossing[] = [];
  for (let i = 0; i < Math.min(count, 3); i++) {
    out.push({
      PathId: `P-${String(idx * 10 + i + 1).padStart(4, "0")}`,
      LevelCrossingId: String(site.LevelCrossingSiteID + i),
      LevelCrossingType: LC_TYPES[(idx + i) % LC_TYPES.length],
      LevelCrossingProtectionType: LC_PROTECTION_TYPES[(idx + i) % LC_PROTECTION_TYPES.length],
    });
  }
  return out;
}

function buildVersions(idx: number): LevelCrossingVersionEntry[] {
  const total = (idx % 3) + 1;
  const users = ["Sue Lappas", "John Carter", "Maria Chen", "Tom Wright"];
  const reasons = [
    "Initial record",
    "Updated protection type after site inspection",
    "Reclassification after works completed",
    "Boundary adjustment",
  ];
  const out: LevelCrossingVersionEntry[] = [];
  for (let v = 1; v <= total; v++) {
    const day = String(((idx + v) % 27) + 1).padStart(2, "0");
    const month = String(((v * 2 + idx) % 12) + 1).padStart(2, "0");
    const year = 2022 + ((v + idx) % 3);
    const start = `${day}/${month}/${year}`;
    const end = v < total ? `${day}/${month}/${year + 1}` : "";
    out.push({
      version: v,
      startDate: start,
      endDate: end,
      reasonForChange: reasons[(idx + v) % reasons.length],
      createdBy: users[(idx + v) % users.length],
      createdDate: `${start} ${String(((idx * 5 + v) % 24)).padStart(2, "0")}:${String(((idx * 7 + v) % 60)).padStart(2, "0")}`,
    });
  }
  return out;
}

export class GetLevelCrossingSites {
  static levelCrossingSites: LevelCrossingSite[] = rawLevelCrossingSites.map((raw, idx) => ({
    ...raw,
    SuburbOrTown: SUBURBS[idx % SUBURBS.length],
    RoadManager: ROAD_MANAGERS[idx % ROAD_MANAGERS.length],
    LocalCouncil: LOCAL_COUNCILS[idx % LOCAL_COUNCILS.length],
    RailInfrastructureManagers: buildRailManagers(idx),
    LinkedLocations: buildLinkedLocations(idx),
    IndividualLevelCrossings: buildIndividualCrossings(idx, raw),
    Version: (idx % 3) + 1,
    Versions: buildVersions(idx),
  }));
}

export class GetLevelCrossingSiteMetadata {
  static metadata: LevelCrossingSiteMetadata[] = [
    {
      id: 1,
      states: [
        { text: "New South Wales", value: "New South Wales" },
        { text: "Victoria", value: "Victoria" },
        { text: "Queensland", value: "Queensland" },
        { text: "Western Australia", value: "Western Australia" },
        { text: "South Australia", value: "South Australia" },
        { text: "Tasmania", value: "Tasmania" },
        { text: "Australian Capital Territory", value: "Australian Capital Territory" },
        { text: "Northern Territory", value: "Northern Territory" },
      ],
      suburbs: SUBURBS.map((s) => ({ text: s, value: s })),
      roadManagers: ROAD_MANAGERS.map((r) => ({ text: r, value: r })),
      localCouncils: LOCAL_COUNCILS.map((c) => ({ text: c, value: c })),
      railInfrastructureManagers: RAIL_MANAGERS.map((r) => ({ text: r, value: r })),
      locationTypes: LOCATION_TYPES.map((t) => ({ text: t, value: t })),
      levelCrossingTypes: LC_TYPES.map((t) => ({ text: t, value: t })),
      levelCrossingProtectionTypes: LC_PROTECTION_TYPES.map((p) => ({ text: p, value: p })),
    },
  ];
}